module.exports = __webpack_public_path__ + "img/noComment.1c140720.png";